import { render, staticRenderFns } from "./RelatorioEmpresasSelector.vue?vue&type=template&id=4a495274&scoped=true"
import script from "./RelatorioEmpresasSelector.vue?vue&type=script&lang=js"
export * from "./RelatorioEmpresasSelector.vue?vue&type=script&lang=js"
import style0 from "./RelatorioEmpresasSelector.vue?vue&type=style&index=0&id=4a495274&prod&scoped=true&lang=css"
import style1 from "./RelatorioEmpresasSelector.vue?vue&type=style&index=1&id=4a495274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a495274",
  null
  
)

export default component.exports